import {
  Component,
  ViewChild,
  TemplateRef,
  OnInit
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as toastr from "toastr";
import * as moment from 'moment';
import * as _ from 'lodash';
import 'moment/min/locales';
import { Subject } from 'rxjs';

import { Holiday } from '@shared/models/holiday.interface';

import { VisitasService } from '../../services/visitas.service';
import { Visit } from '../../models/visit.interface';


import {Router} from "@angular/router"
import { CanTransmitVisitsOfWeekService } from './services/can-transmit-visits-of-week.service';

const colors: any = {
  weekEnd: {
    primary: '#c2c2c2',
    secondary: '#e2e2e2'
  },
  red: {
    primary: '#e06666',
    secondary: '#FAE3E3'
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF'
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA'
  },
  green: {
    primary: '#2fa192',
    secondary: '#2fa192'
  },
  blue2: {
    primary: '#99dbf7',
    secondary: '#99dbf7'
  },
  lightBlue: {
    primary: '#9090e9',
    secondary: '#9090e9'
  }

};

@Component({
  selector: 'app-home-visita',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  providers: [CanTransmitVisitsOfWeekService]
})

export class VisitaHomeComponent implements OnInit {
  agendamentos: any;
  isRequesting: boolean = false;
  canTransmitPlanningBool;

  week = {
    start: moment().startOf('isoWeek'),
    end: moment().endOf('isoWeek'),
    formatedStart: moment().startOf('isoWeek').format('DD/MM/YYYY'),
    formatedEnd: moment().endOf('isoWeek').format('DD/MM/YYYY')
  };

  holidays: Holiday[] = [];
  holidaysSAC: Holiday[] = [];

  weekEndLabel = { title: "Fim de semana", color: colors.weekEnd.primary };
  feriadosLabel = { title: "Feriados", color: colors.red.primary };
  feriadosEstaduaisLabel = { title: "Feriados estaduais", color: colors.lightBlue.primary };
  transmitido = { title: "Transmitido", color: colors.green.primary };
  naoTransmitido = { title: "Não transmitido", color: colors.yellow.primary };
  statuSemVisita = { title: "Status s/ agenda", color: colors.blue2.primary };
  labels: any = [this.weekEndLabel, this.feriadosLabel, this.feriadosEstaduaisLabel, this.transmitido, this.naoTransmitido, this.statuSemVisita];

  userLogado;

  canTransmitPlanning: boolean = false;

  @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;

  refresh: Subject<any> = new Subject();

  activeDayIsOpen: boolean = true;

  constructor(
    private modal: NgbModal,
    private visitasService: VisitasService,
    private router: Router,
    private canTransmitVisitsOfWeekService: CanTransmitVisitsOfWeekService,
    ) { }

  ngOnInit() {
    this.userLogado = JSON.parse(localStorage.getItem("user_logado"));
    this.userLogado.perfil != 1 ? this.router.navigate(['/visitas/controle']) : '';

    this.agendamentos = null;
    let sched = {
      dates: this.getDaysOfWeek(this.week),
      items: this.getItemsOfDay(this.week)
    };
    this.agendamentos = sched;

    //this.getHolidays(this.week);
    this.getFeriados();
    this.getFeriadosSAC();
    this.getScheduledVisits(this.week);

    this.CheckPossibilityOfTransmit(this.week);

  }

  getLabels(): void {

  }

  openItem(item: any): void {
    //console.log('openItem', item);
  }

  changeWeek(direction: string): void {
    this.labels = [this.weekEndLabel, this.feriadosLabel, this.feriadosEstaduaisLabel, this.transmitido, this.naoTransmitido];

    let currentWeek = this.week;
    let setWeek = currentWeek;

    if (direction == 'back') {

      let date = moment(currentWeek.start).subtract(7, 'd');
      this.week = {
        start: moment(date.startOf('isoWeek')),
        end: moment(date.endOf('isoWeek')),
        formatedStart: date.startOf('isoWeek').format('DD/MM/YYYY'),
        formatedEnd: date.endOf('isoWeek').format('DD/MM/YYYY')
      }

    }

    if (direction == 'next') {

      let date = moment(currentWeek.end).add(1, 'd');
      this.week = {
        start: moment(date.startOf('isoWeek')),
        end: moment(date.endOf('isoWeek')),
        formatedStart: date.startOf('isoWeek').format('DD/MM/YYYY'),
        formatedEnd: date.endOf('isoWeek').format('DD/MM/YYYY')
      }

    }

    //this.getHolidays(this.week);
    this.getScheduledVisits(this.week);
  }


  getSemana(visitas) {
    this.visitasService.getProximaSemana().subscribe(
      proximaSemanaDuloren => {

        console.log("start", this.week.start)

        console.log("end", this.week.end)
        this.canTransmitPlanning =  this.canTransmitVisitsOfWeekService.execute(
          proximaSemanaDuloren,
          this.week.start,
          this.week.end,
          visitas
        )
      },
      error => console.log(error)
    );
  }

  getFeriados(week: number = -1, data: any = null ) {
    this.visitasService.getFeriados(this.week.start.format("YYYY-MM-DD"), this.week.end.format("YYYY-MM-DD")).subscribe(
      resp => {
        this.holidays = resp;
        this.mountGrid(week, data);
      },
      error => console.log(error)
    );
  }

  getFeriadosSAC(week: number = -1, data: any = null ) {
    this.visitasService.getFeriadosSAC(this.week.start.format("YYYY-MM-DD"), this.week.end.format("YYYY-MM-DD")).subscribe(
      resp => {
        this.holidaysSAC = resp;
        this.mountGrid(week, data);
      },
      error => console.log(error)
    );
  }

  /*getHolidays(week) {
    return this.visitasService
               .getHolidays(moment(week.start).format('YYYY-MM-DD'), moment(week.end).format('YYYY-MM-DD'))
               .subscribe(holidays => this.holidays = holidays);
  }*/

  getScheduledVisits(week) {
    return this.visitasService
               .getScheduledVisits(this.userLogado.id, moment(week.start).format('YYYY-MM-DD'), moment(week.end).format('YYYY-MM-DD'))
               .subscribe(data => {
                this.getFeriados(week, data);
                this.getFeriadosSAC(week, data);
                this.getSemana(data);

                this.CheckPossibilityOfTransmit(this.week);
               });
  }

  CheckPossibilityOfTransmit(week) {
    return this.visitasService
               .CheckPossibilityOfTransmit(this.userLogado.id, moment(week.start).format('YYYY-MM-DD'), moment(week.end).format('YYYY-MM-DD'))
               .subscribe(data => {
                this.canTransmitPlanningBool = data;
                console.log("podeTransmitir", this.canTransmitPlanningBool);
               });
  }



  mountGrid(week: any, data: any) {
    this.agendamentos = [];
    let sched = {
      dates: this.getDaysOfWeek(week),
      items: this.getItemsOfDay(week, data)
    };
    this.agendamentos = sched;
  }

  getDaysOfWeek(week: any): moment.Moment[] {
    let dateArr: moment.Moment[] = [];
    let start = moment(week.start);

    while (start < week.end) {
      dateArr.push(moment(start));
      start.add(1, 'd');
    }

    return dateArr;
  }

  getItemsOfDay(week: any, data: Visit[] = []): any {

    let ar: any = [];
    let c = 0;
    let maxVisits = 0;

    let visitsPerDay = [];

    if (data.length > 0) {
      let date = moment(week.start);
      while (date < week.end) {
        let index = date.day();
        visitsPerDay[index] = data.filter( d => moment(d.dataAgendamento).day() == date.day() ) || [];
        maxVisits = Math.max(maxVisits, visitsPerDay[index].length);
        date.add(1, 'd');
      }
    }

    let length = Math.max(maxVisits, 8);

    while (c < length) {

      let r: any = {
        Id: 1,
        subItems: []
      };

      let start = moment(week.start);
      while (start < week.end) {

        let color = '';

        if (start.day() == 0 || start.day() == 6) {
          color = colors.weekEnd.primary;
        }

        this.holidays.forEach(e=>{ //marca os feriados
          let dt = moment(e.data);
          if(moment(dt).isSame(start) ){
            color = colors.red.primary
          }
        })

        this.holidaysSAC.forEach(e=>{ //marca os feriados
          let dt = moment(e.data);
          if(moment(dt).isSame(start) ){
            color = colors.lightBlue.primary
          }
        })

        let d = {};

        if (visitsPerDay[start.day()] && visitsPerDay[start.day()].length >= c+1){
          let visit = visitsPerDay[start.day()][c];
          let button_color = '';
          if(visit.formaVisita == "status_sem_agendamento")
          {
            button_color = colors.blue2.primary;
          }
          else
          {
            visit.statusUltimaVisita == 'PL' ? button_color = colors.yellow.primary : button_color = colors.green.secondary;
          }
          

          if(visit.feriadoEstadualBool){
            d = {
              id: visit.id,
              day: moment(visit.dataAgendamento),
              title: visit.razaoSocial,
              color: colors.lightBlue.primary,
              button_color: button_color,
              available: false,
              idCliente: visit.idCliente,
              idSetor: visit.idSetor,
              idFilial: visit.idFilial,
              dataPrev: visit.dataPrev,
              dataAgendamento: visit.dataAgendamento
            };
          }else{
            d = {
              id: visit.id,
              day: moment(visit.dataAgendamento),
              title: visit.razaoSocial,
              color: color,
              button_color: button_color,
              available: false,
              idCliente: visit.idCliente,
              idSetor: visit.idSetor,
              idFilial: visit.idFilial,
              dataPrev: visit.dataPrev,
              dataAgendamento: visit.dataAgendamento
            };
          }



        }
        else{

          d = {
            id: -1,
            day: moment(start),
            title: '',
            color: color,
            available: true,
            idCliente: null,
            idSetor: null,
            idFilial: null,
            dataPrev: null,
            dataAgendamento: null
          };
        }

        r.subItems.push(d);
        start.add(1, 'd');
      }

      ar.push(r);
      c += 1;
    }

    return ar;

  }

  format(momentDate, formatString){
    return moment(momentDate).locale('pt-BR').format(formatString);
  }

  print(){
    let filter = {
      dataInicial: this.week.start.format("YYYY-MM-DD"),
      dataFinal: this.week.end.format("YYYY-MM-DD"),
      agent: this.userLogado.idSetor,
      vendedorId: this.userLogado.id
    }
    this.visitasService.imprimirPlanejamento(filter).subscribe(
      response => {
        window.open(URL.createObjectURL(new Blob([response.blob()], { type: 'application/pdf' })), '', 'width=1000,height=900')
      },
      error => this.actionsForError("Falha ao imprimir")
    );
  }

  close(){

  }

  transmit(){
    let filter = {
      dataInicial: this.week.start.format("YYYY-MM-DD"),
      dataFinal: this.week.end.format("YYYY-MM-DD"),
      agent: this.userLogado.idSetor,
      vendedorId: this.userLogado.id
    }
    this.visitasService.transferirPlanejamento(filter).subscribe(
      resp => {
        this.actionsForSuccess("Transmissão realizada com sucesso")
        this.getFeriados() //reload grid
        this.getFeriadosSAC();
        this.getScheduledVisits(this.week) //reload grid
      },
      error=> {
        this.actionsForError(JSON.parse(error._body).message)
      }
    )
  }

  private actionsForSuccess(message){
    toastr.success(message);
  }

  private actionsForError(message){
      toastr.error(message);
  }

}
